<template lang="pug">
  div
    app-header
      .AnalyticsMenu
        b.Menu-title АНАЛИТИКА:
        .AnalyticsMenu-nav
          header-button(
            :isActive="panels.table",
            title="Таблица",
            icon="IconPanelTable",
            @clicked="panels.table = !panels.table"
          )
          header-button(
            :isActive="panels.chart",
            title="График",
            icon="IconPanelChart",
            @clicked="panels.chart = !panels.chart"
          )
    .SP(v-if='workspace')
      splitpanes.hscreen(
        horizontal,
        @resized='resized',
        @ready='ready = true',
        ref="panes")
        pane(
          size="40",
          v-if='ready',
          :dbl-click-splitter="false")
          layout-panel(
            :hasHeader='false')
            template(v-slot:content="")
              analytics-map(
              :resize='newMapContainerSize')
        pane(
          size="30",
          :dbl-click-splitter="false",
          v-if='panels.chart')

          layout-panel(
            :hasHeader='false')
            template(v-slot:content="")
              analytics-chart(
                @hidemain='panels.chart = false',
                @openPeriodPanel='periodPanelSettings = $event',
                :initialSelectedIntervals='selectedIntervals')
        pane(
          size="30",
          :dbl-click-splitter="false",
          v-if='panels.table')

          layout-panel(
            :hasHeader='false',
            :isMaximized="isTableMaximized")
            template(v-slot:content="")
              analytics-table(
                @changeSettings='tableSettings = $event',
                :initialSettings='tableSettings',
                :isMaximized='isTableMaximized',
                @toggleMaximise='isTableMaximized = !isTableMaximized',
                v-if='analyticsColumnSubTypes')

      period-panel(
        v-click-outside='hidePeriodPanel',
        v-if='periodPanelSettings',
        @close='hidePeriodPanel',
        @intervalsChanged='changeIntervals',
        :settings='periodPanelSettings')

</template>

<script>
  import ClickOutside from 'vue-click-outside'
  import { Splitpanes, Pane } from '@/components/splitpanes'
  import AnalyticsMap from '@/components/analytics/Map.vue'
  export default {
    name: 'Analytics',
    components: {
      'app-header': () => import('@/components/AppHeader'),
      'header-button': () => import('@/components/HeaderButton'),
      'layout-panel': () => import('@/components/LayoutPanel'),
      'period-panel': () => import('@/components/analytics/PeriodPanel.vue'),
      'analytics-chart': () => import('@/components/analytics/Chart.vue'),
      'analytics-table': () => import('@/components/analytics/AnalyticsTable.vue'),
      AnalyticsMap,
      Splitpanes,
      Pane,
    },
    directives: {
      ClickOutside
    },
    data() {
      return {
        ready: false,
        periodPanelSettings: null,
        newMapContainerSize: null,
        tableSettings: null,
        panels: {
          table: true,
          chart: true
        },
        selectedIntervals: [],
        isTableMaximized: false
      }
    },
    computed: {
      workspace() {
        return this.$store.getters.workspace
      },
      workspaceAndVersion() {
        return {
          workspace: this.$store.getters.workspace,
          version: this.$store.getters.version
        }
      },
      analyticsColumnSubTypes() {
        return this.$store.getters.analyticsColumnSubTypes
      }
    },
    watch: {
      workspaceAndVersion(newVal, oldVal) {
        if(oldVal.workspace && oldVal.version) {
          this.tableSettings = null
          this.periodPanelSettings = null
          this.$store.dispatch('clearFullAnalyticsStore')
          this.$store.dispatch('getAnalyticsColumnSubTypes')
        }
      }
    },
    mounted() {
      if(!this.analyticsColumnSubTypes && this.workspace) {
        this.$store.dispatch('getAnalyticsColumnSubTypes')
      }
    },
    destroyed() {
      this.$store.dispatch('clearFullAnalyticsStore')
    },
    methods: {
      resized() {
        this.newMapContainerSize = {}
      },
      hidePeriodPanel() {
        this.periodPanelSettings = null
      },
      changeIntervals($event) {
        this.selectedIntervals = $event
        this.hidePeriodPanel()
      }
    }
  }

</script>

<style scoped lang="scss">
  @import '~base';
  .AnalyticsMenu {
    display: flex;
    align-items: center;

    &-nav {
      display: flex;
      align-items: center;
      margin-left: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Analytics.vue